import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { withGoogleReCaptcha } from '@dpdgroupuk/react-google-recaptcha-v3';
import { withProps } from 'recompose';

import { withCollection } from './hocs';
import CollectionRoutes from './routes';
import { fetchCacheableCollection } from '../../store/actions/collections';
import { ACTION } from '../../constants/recaptcha';
import withFetch from '../../HOCs/withFetch';

export default compose(
  withRouter,
  withGoogleReCaptcha,
  withProps(({ match, reCaptchaConfig }) => ({
    fetchCacheableCollectionWithRecaptcha: async dispatch => {
      const collectionCode = match.params.collectionId;
      const token = await reCaptchaConfig.executeRecaptchaAsync(
        ACTION.GET_COLLECTION
      );

      return dispatch(fetchCacheableCollection(collectionCode, token));
    },
  })),
  withFetch(props => props.fetchCacheableCollectionWithRecaptcha),
  withCollection
)(CollectionRoutes);
